import { Link } from 'react-router'
import { Input, Radio } from 'antd'
import { SearchOutlined } from '@ant-design/icons'
import { useSelector } from 'react-redux'
// import ym from 'react-yandex-metrika'
import { useTranslation } from 'react-i18next'
import { useCallback, useEffect, useState } from 'react'
import { routeCodes } from '@/constants/routes'
import { ActiveLink } from '@/components/utils'
import { Text, Screen } from '@/components/ui'
import searchIcon from '../../../assets/images/icon-search.svg'
import logo from '../../../assets/images/icon-logo.svg'
import heartIcon from '../../../assets/images/icon-heart.svg'
import messagesIcon from '../../../assets/images/icon-messages.svg'
import notificationIcon from '../../../assets/images/icon-notification.svg'
import noAvatar from '../../../assets/images/avatar.png'
// import { IS_PROD } from '@/constants/env'
import { RootState } from '@/store'
import { IUser } from '@/models'
import { MEDIATEKA_DOWNLOAD } from '@/constants/urls'
import { useAppSelector } from '@/hooks/useReduxHooks'
import { getLang, setLang } from '@/helpers/langUtils'
import s from './header.module.scss'

interface IHeaderProps {
  isAuth: boolean
}

const Header = ({ isAuth }: IHeaderProps) => {
  const user = useSelector<RootState, IUser | null>((state) => state.user.data)
  const isRector = useAppSelector((state) => state.user.isRector)
  const isTopManager = useAppSelector((state) => state.user.isTopManager)
  const { t, i18n } = useTranslation()
  const [currentLang, setCurrentLang] = useState<string>()

  // const handleClick = (ymGoal: string) => {
  // if (IS_PROD && ymGoal) ym('reachGoal', ymGoal)
  // }

  const getAvatar = () => {
    if (
      process.env.PROJECT === 'fssp' ||
      !user?.avatar_image_file_name ||
      user?.avatar_image_file_name === '00000000-0000-0000-0000-000000000000'
    )
      return noAvatar
    return `${MEDIATEKA_DOWNLOAD}/${user.avatar_image_file_name}`
  }

  const handleChangeLanguage = (lang: string) => {
    i18n.changeLanguage(lang)
    setLang({ lang })
    setCurrentLang(lang)
  }

  const getCurrentLang = useCallback(async () => {
    if (user) {
      i18n.changeLanguage('ru')
      setLang({ lang: 'ru' })
      setCurrentLang('ru')
    } else {
      const currentLang = await getLang()
      i18n.changeLanguage(currentLang?.lang ?? 'ru')
      setLang({ lang: currentLang?.lang ?? 'ru' })
      setCurrentLang(currentLang?.lang ?? 'ru')
    }
  }, [i18n, user])

  useEffect(() => {
    getCurrentLang().then(null)
  }, [getCurrentLang, i18n.language])

  return (
    <header className={s.header}>
      {/* <Link
        to={isRector || isTopManager ? {} : !user ? 'https://we-joined.ru' : routeCodes.DASHBOARD}
        // onClick={() => handleClick('linkDashboard')}
      > */}
      <div className={s.header__logo}>
        <img src={logo} alt='logo' />
        {/* <Screen size='lg'> */}
        <Text className={s['logo-text']} size='sm' transform='uppercase' weight='bold' whiteSpace='pre-line'>
          {t('auth.header.logo')}
        </Text>
        {/* </Screen> */}
      </div>
      {/* </Link> */}

      {/* {!user && (
        <Radio.Group
          value={currentLang}
          size='small'
          onChange={(e) => handleChangeLanguage(e.target.value)}
          style={{ marginRight: 16 }}
          optionType='button'
          buttonStyle='solid'
        >
          <Radio.Button value='ru' type='primary'>
            ру
          </Radio.Button>
          <Radio.Button value='en' type='primary'>
            en
          </Radio.Button>
        </Radio.Group>
      )} */}

      {/* {!isAuth && (
        <>
          {!(isRector || isTopManager) && (
            <div className={s['header-content']}>
              <Screen size='sm'>
                <ul className={s.header__menu}>
                  <li className={s['menu-item']}>
                    <ActiveLink
                      to={routeCodes.SURVEYS}
                      className={s.link}
                      activeClassName={s.active}
                      // onClick={() => handleClick('linkSurveys')}
                    >
                      <Text size='md' align='center' weight='bold'>
                        Опросы
                      </Text>
                    </ActiveLink>
                  </li>
                  <li className={s['menu-item']}>
                    <ActiveLink
                      to={routeCodes.EVENTS}
                      className={s.link}
                      activeClassName={s.active}
                      // onClick={() => handleClick('linkEvents')}
                    >
                      <Text size='md' align='center' weight='bold'>
                        Мероприятия
                      </Text>
                    </ActiveLink>
                  </li>
                  <li className={s['menu-item']}>
                    <ActiveLink
                      to={routeCodes.MY_OPPORTUNITIES}
                      className={s.link}
                      activeClassName={s.active}
                      // onClick={() => handleClick('linkOpportunities')}
                    >
                      <Text size='md' align='center' weight='bold'>
                        Мои возможности
                      </Text>
                    </ActiveLink>
                  </li>
                  <li className={s['menu-item']}>
                    <ActiveLink
                      to={routeCodes.REWARDS_SHOP}
                      className={s.link}
                      activeClassName={s.active}
                      // onClick={() => handleClick('linkRewards')}
                    >
                      <Text size='md' align='center' weight='bold'>
                        Магазин наград
                      </Text>
                    </ActiveLink>
                  </li>
                </ul>
              </Screen>
              <Screen size='md'>
                <div className={s.header__search}>
                  <Input
                    name='header-search'
                    size='large'
                    placeholder='Поиск по ресурсу...'
                    prefix={<SearchOutlined />}
                    disabled
                  />
                </div>
              </Screen>
            </div>
          )}

          <div className={s.header__user}>
            <ul className={s['user-buttons']}>
              {!(isRector || isTopManager) && (
                <>
                  <Screen size='md' down>
                    <li className={s['user-buttons__item']}>
                      <img src={searchIcon} alt='search' />
                    </li>
                  </Screen>
                  <li className={s['user-buttons__item']}>
                    <img src={heartIcon} alt='favorite' />
                  </li>
                </>
              )}
              <li className={s['user-buttons__item']}>
                <img src={messagesIcon} alt='messages' />
              </li>
              <li className={s['user-buttons__item']}>
                <img src={notificationIcon} alt='notification' />
              </li>
            </ul>
            <div className={s['user-photo']}>
              <Link to={isRector || isTopManager ? {} : routeCodes.PROFILE_NEW}>
                <img src={isTopManager ? noAvatar : getAvatar()} alt='user' />
              </Link>
            </div>
          </div> */}
      {/* </> */}
      {/* )} */}
    </header>
  )
}

export default Header
